import { render, staticRenderFns } from "./IMRFile2PDFSample.vue?vue&type=template&id=36d7e541"
import script from "./IMRFile2PDFSample.vue?vue&type=script&lang=js"
export * from "./IMRFile2PDFSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports